import continentsList from "./continents";
import countriesList from "./countries";
import decisionTypeList from "./decision-type";
import timePeriodList from "./time-period";

export default [...countriesList, ...continentsList, ...decisionTypeList, ...timePeriodList];
